import React from 'react';

import TomTomLogoIcon from '../../images/tomtom-pin.svg';

const LogoIcon = () => {
  return <img height="38" src={TomTomLogoIcon} alt="TomTom logo" />;
};

export default LogoIcon;
